import React, {useMemo, useState} from 'react';
import {Outlet} from 'react-router-dom';

import Navbar from '../components/common/Navbar';
import {useMemberStatisticsQuery} from '../generated';

const MerchantsLayout = () => {
  const {data: stats} = useMemberStatisticsQuery();
  const [searchPhrase, setSearchPhrase] = useState('');

  const tabs = useMemo(
    () => [
      {
        name: 'All',
        count: stats?.memberStatistics.merchantCount.all,
        link: '/merchants',
      },
      {
        name: 'Active',
        count: stats?.memberStatistics.merchantCount.approved,
        link: '/merchants/active',
      },
      {
        name: 'Pending',
        count: stats?.memberStatistics.merchantCount.pending,
        link: '/merchants/pending',
      },
      {
        name: 'Deactivated',
        count: stats?.memberStatistics.merchantCount.rejected,
        link: '/merchants/deactivated',
      },
    ],
    [stats]
  );

  return (
    <div className="flex h-full flex-col">
      <div className="flex-2">
        <Navbar
          title="Merchants"
          tabs={tabs}
          placeholder="Find a merchants..."
          setSearchPhrase={setSearchPhrase}
        />
      </div>
      <div className="flex-1 overflow-y-scroll scroll-smooth px-11 py-7 pb-0">
        <Outlet context={[searchPhrase]} />
      </div>
    </div>
  );
};

export default MerchantsLayout;
